export default __webpack_public_path__ + "f90b49d09665617ce56a374d42a51422.png";